import React from "react";

const ScrollableElementWrapper = ({ children }) => (
  <div style={{ overflow: "auto" }}>{children}</div>
);

export default ScrollableElementWrapper;



// WEBPACK FOOTER //
// ./src/components/CommonModels/ScrollableElementWrapper.js